import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Handshake, TrendingUp, ShieldCheck, ArrowRight } from 'lucide-react';

export default function PartnersPage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);
  const perks = [
    { id: 'register-deals', icon: Handshake, title: 'Register deals', desc: 'Protect pipeline with deal registration and approval workflows.' },
    { id: 'grow-with-us', icon: TrendingUp, title: 'Grow with us', desc: 'Access enablement, pre-sales support and co-marketing.' },
    { id: 'certified-delivery', icon: ShieldCheck, title: 'Certified delivery', desc: 'Deliver Visotonics services with certified implementation playbooks.' },
  ];
  return (
    <div>
      <section className="relative py-24 border-b border-white/5">
        <div className="absolute inset-0 viso-grid opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-widest text-cyan-300 mb-3">Partner Program</div>
          <h1 className="font-display text-4xl md:text-6xl font-bold max-w-4xl leading-[1.05]"><span className="text-gradient">Build, sell and deliver Physical AI with Visotonics.</span></h1>
          <p className="text-slate-400 mt-5 max-w-2xl">Register as a Visotonics partner — protect deals, unlock deal creation rights, and access certified enablement.</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/partner/register"><Button className="bg-cyan-400 hover:bg-cyan-300 text-slate-900">Become a partner <ArrowRight className="w-4 h-4 ml-1" /></Button></Link>
            <Link to="/login"><Button variant="outline" className="border-white/15 bg-white/5 hover:bg-white/10 text-slate-100">Partner login</Button></Link>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-5">
          {perks.map((p) => (
            <div id={p.id} key={p.title} className="scroll-mt-24 rounded-2xl border border-white/10 bg-white/[0.02] p-7 hover:border-cyan-400/30 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-cyan-400/10 border border-cyan-400/20 flex items-center justify-center">
                <p.icon className="w-5 h-5 text-cyan-300" />
              </div>
              <div className="font-display text-xl font-semibold mt-4">{p.title}</div>
              <p className="text-slate-400 mt-2 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
